import * as IF from "infrontjs";
import template from './template.html';

class RoutineSelectionItem extends HTMLElement
{
    static get observedAttributes()
    {
        return [ 'weekly-frequence' ];
    }

    get customWeeklyFrequencies()
    {
        let ret = null,
            cwf = this.getAttribute( 'custom-weekly-frequencies' );

        if ( cwf && cwf.length > 0 )
        {
           cwf = cwf.split( ";" );
           if ( cwf && cwf.length > 0 )
           {
               ret = cwf;
           }
        }

        return ret;
    }

    get weeklyFrequence()
    {
        let ret = this.getAttribute( 'weekly-frequence' );
        if ( ret )
        {
            return ret;
        }
        else
        {
            return 0;
        }
    }

    constructor()
    {
        super();
        this._isConnected = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.root = this;
            this.app = IF.App.get();
            this.namePattern = this.getAttribute( 'name' );
            this.render();

            this.container = this.root.querySelector( '[data-type="routine-selection"]' );
            this.root.addEventListener( 'click', () =>
            {
                if ( null !== this.customWeeklyFrequencies )
                {
                    const wfContainer = this.app.gui.getWeeklyFrequenceModalContainer();
                    wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( btn =>
                    {
                        btn.addEventListener( 'click', () => {
                            this._onFrequenceSelection( btn.getAttribute( 'data-times' ) );
                        });
                    });
                    wfContainer.querySelector( '[data-type="modal-closer"]' ).addEventListener( 'click', () =>
                    {
                        wfContainer.querySelector( '[data-type="modal-closer"]' ).removeEventListeners( 'click' );
                        this.app.gui.hideFrequenceModal();
                    });
                    this.app.gui.showFrequenceModal( this.customWeeklyFrequencies );
                }
                else
                {
                    if ( this.container.classList.contains( 'checked' ) )
                    {
                        this.container.classList.remove( 'checked' );
                        this.setAttribute( 'checked', false );
                    }
                    else
                    {
                        this.container.classList.add( 'checked' );
                        this.setAttribute( 'checked', true);
                    }
                }
            });

            this._isConnected = true;
        }
    }

    _onFrequenceSelection( times )
    {
        const wfContainer = this.app.gui.getWeeklyFrequenceModalContainer();
        wfContainer.querySelectorAll( '[data-type="weeklyFrequenceButton"]' ).forEach( (btn) =>
        {
            btn.removeEventListeners( 'click' );
        });
        this.setAttribute( 'weekly-frequence', times );
        if ( 0 === parseInt( times ) )
        {
            this.removeAttribute( 'checked' );
        }
        else
        {
            this.setAttribute( 'checked', true );
        }
        this.app.gui.hideFrequenceModal();
    }

    disconnectedCallback()
    {}

    attributeChangedCallback( name, oldVal, newVal )
    {
        if ( this._isConnected )
        {
            if ( name === 'name' || name === 'checked' )
            {
                // Do nothing
            }
            else
            {
                this.render();
            }
        }
    }

    render()
    {
        let label = this.namePattern;
        let isChecked = false;
        if ( null !== this.customWeeklyFrequencies )
        {
            let replacer = '_';
            if ( 0 < this.weeklyFrequence )
            {
                replacer = this.weeklyFrequence;
                isChecked = true;
            }
            else
            {
                isChecked = false;
            }
            label = label.replace( "__WT__", replacer );
        }

        this.setAttribute( 'name', label );

        this.root.innerHTML = this.app.view.getHtml(
            template,
            {
                name : label,
                icon : this.getAttribute( 'icon' ),
                isChecked : isChecked
            }
        );
    }

}

customElements.define('routine-selection-item', RoutineSelectionItem );
